window.addEventListener("DOMContentLoaded", (event) => {
  const contactForm = document.contact;

  contactForm.addEventListener("submit", async function (evt) {
    contactForm.querySelector("button").disabled = true;
    contactForm.querySelector("button").textContent = "Invio in corso...";
    contactForm.querySelector(".alert-success").style.display = "none";
    contactForm.querySelector(".alert-danger").style.display = "none";
    evt.preventDefault();
    const formData = new FormData(this);

    let resp = await fetch("api/contact.php", {
      method: "post",
      body: formData,
    });
    if (resp.status == 200) {
      contactForm.name.value = "";
      contactForm.email.value = "";
      contactForm.phone.value = "";
      contactForm.text.value = "";
      contactForm.querySelector(".alert-success").style.display = "block";
    } else {
      contactForm.querySelector(".alert-danger").style.display = "block";
    }
    contactForm.querySelector("button").disabled = false;
    contactForm.querySelector("button").textContent = "INVIA";
  });
});
